module.exports = [
  // type
  require('./Fraction'),

  // construction function
  require('./function/fraction')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/fraction/index.js
// module id = 1297
// module chunks = 0